import { useState } from "react";
import { useAuth } from "../helpers/useAuth";
import { api } from "../helpers/api";
import styles from "./ImpersonationBanner.module.css";

export function ImpersonationBanner() {
  const { authState, isImpersonating } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!isImpersonating || authState.type !== "authenticated") {
    return null;
  }

  const user = authState.user;
  const displayName = user.displayName || user.email;

  const handleStopImpersonation = async () => {
    setLoading(true);
    try {
      await api.post("/_api/admin/users/stop-impersonate");
      // Supprimer le cookie côté client aussi par sécurité
      document.cookie = "keno_impersonator=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
      window.location.href = "/espace-admin/users/";
    } catch (err) {
      setLoading(false);
      alert("Erreur lors de la déconnexion : " + (err instanceof Error ? err.message : String(err)));
    }
  };

  return (
    <div className={styles.banner}>
      <span className={styles.text}>
        Connecté en tant que <strong>{displayName}</strong>
      </span>
      <button
        className={styles.button}
        onClick={handleStopImpersonation}
        disabled={loading}
      >
        {loading ? "Retour..." : "Revenir à mon compte"}
      </button>
    </div>
  );
}
